import script from "./List.vue?vue&type=script&setup=true&async=true&lang=js"
export * from "./List.vue?vue&type=script&setup=true&async=true&lang=js"

import "./List.vue?vue&type=style&index=0&id=27a10c2c&lang=scss"

const __exports__ = script;

export default __exports__